import { withTranslation } from 'react-i18next';
import Footer from './Footer.layout';

export default withTranslation('common')(Footer);
